<div class="loadingBox" *ngIf="!loaded">
   <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
  </div>
 <div *ngIf="loaded">
    <section *ngIf="MTNFail" class="login-main-wrapper full-height">
        <div class="container-fluid pl-0 pr-0">
           <div class="row no-gutters row justify-content-center ">
              <div class="col-md-5 p-5 bg-dark-style authbox">
                 <div class="login-main-left">
                    <div class="text-center mb-5 login-main-left-header">
                       <img src="assets/img/hostbrand/core-logo.svg" width="300" class="img-fluid" alt="LOGO">
                       <hr>
                       <p>Auto Login Failed - please contact your network provider for more details.</p>
                       </div>
                       </div>
                       </div>
                       </div>
                       </div>
                       </section>
                       <section *ngIf="!MTNFail" class="login-main-wrapper full-height">
                        <div class="container-fluid pl-0 pr-0">
                           <div class="row no-gutters row justify-content-center ">
                              <div class="col-md-5 p-5 bg-dark-style authbox">
                                 <div class="login-main-left">
                                    <div class="text-center mb-5 login-main-left-header">
                                       <img src="assets/img/hostbrand/core-logo.svg" width="300" class="img-fluid" alt="LOGO">
                                       
                                         </div>
                                         
                                    
                                    <div class="text-center">
                                       <button class="form-control"><a href="{{doi}}">
                                          <span>Login</span>
                                       </a>
                                      </button> 
                                      <br>
                                      <button class="form-control"><a href="{{doi}}">
                                       <span>Register</span>
                                    </a>
                                   </button>  
                                    </div>
                                 </div>
                              </div>
                        </div>
                        </div>
                     </section>
<!-- <section *ngIf="!MTNFail" class="login-main-wrapper full-height">
    <div class="container-fluid pl-0 pr-0">
       <div class="row no-gutters row justify-content-center ">
          <div class="col-md-5 p-5 bg-dark-style authbox">
             <div class="login-main-left">
                <div class="text-center mb-5 login-main-left-header">
                   <img src="assets/img/hostbrand/core-logo.svg" width="300" class="img-fluid" alt="LOGO">
                   
                     </div>
                     <form name="sample-form" #f="ngForm">
                        <div *ngIf="!hideUsername" class="form-group">
                        <label i18n="@@Mobile Number | Mobile Number Label">Mobile number</label><br/>
                <international-phone-number #username [(ngModel)]="mobNum" (change)="onUsernameUp($event)" placeholder="Enter phone number" i18n-placeholder="Enter Phone Number" [maxlength]="20"  [required]="true" [defaultCountry]="'za'" #phoneNumber="ngModel" name="phone_number"  [allowedCountries]="['za','tn', 'eg', 'dz', 'kw', 'ae', 'ng']"></international-phone-number>
                
                 <div *ngIf="f.submitted && !phoneNumber.valid" i18n="@@Phone number is required and should be valid | Phone Number Validation Message if not accepted" class="help-block">Phone number is required and should be valid</div>
                     </div>
                     
                                <div class="form-group">
                                        <label i18n="@@Password | Password Label">Password</label>
                                        <input minlength=6 type="password" (change)="onPasswordUp($event)" #password class="form-control" placeholder="">
                                </div>
                                <button *ngIf="!hideUsername" (click)="loginUser(username.value,password.value)" type="button" class="form-control">
                                    <span i18n="@@Login | Login Button">Login</span>
                                  </button>
                                  <button *ngIf="hideUsername"  (click)="loginUserwithID(password.value)" type="button" class="form-control">
                                    <span i18n="@@Login | Login Button">Login</span>
                                  </button>
                                </form>
                  <button  routerLink="/forgot-password" class="form-control">
                      <span i18n="@@Reset Password | Reset Password Button">Reset Password</span>
                  </button>
                <div class="text-center">
                  <br/>
                   <p class="light-gray" i18n="@@Don’t have an account? | Don’t have an account message">Don’t have an account?</p><p> <a i18n="@@Sign up | Signup Button" routerLink="/register">  Sign Up</a></p>
                </div>
             </div>
          </div>
    </div>
    </div>
 </section> -->
 </div>